import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

import { TransientProps } from '@common/types';

export const Container = styled.article`
  height: 100%;
`;

export const PageHeader = styled.header`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    gap: 0.75rem;

    h1 {
      font-size: 1.375rem;
      font-weight: 800;
      color: ${theme.colors.foreground[100]};
      letter-spacing: -0.5px;
    }
  `}
`;

export const PageHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const BackButton = styled.button`
  ${({ theme }) => css`
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.75rem;
    border: none;
    background: transparent;
    cursor: pointer;
    color: ${theme.colors.brand.primary.default};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.opaque};
    }
  `}
`;

export const CountBadge = styled.span`
  ${({ theme }) => css`
    border-radius: 9999px;
    background: ${theme.colors.brand.primary.opaque};
    color: ${theme.colors.brand.primary.default};
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.25rem 0.75rem;
  `}
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 280px;
`;

export const SearchIcon = styled.span`
  ${({ theme }) => css`
    position: absolute;
    left: 0.875rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${theme.colors.foreground[40]};
    display: flex;
    align-items: center;
    pointer-events: none;
  `}
`;

export const SearchInput = styled.input`
  ${({ theme }) => css`
    width: 100%;
    height: 2.625rem;
    border: 1.5px solid ${theme.colors.base.border};
    border-radius: 9999px;
    padding-left: 2.625rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    color: ${theme.colors.foreground[100]};
    background: transparent;
    outline: none;
    transition: ${theme.transition.default};

    ::placeholder {
      color: ${theme.colors.foreground[40]};
    }

    :focus {
      border-color: ${theme.colors.brand.primary.default};
      box-shadow: 0 0 0 3px ${theme.colors.brand.primary.opaque};
    }
  `}
`;

export const CategoryFilters = styled.div`
  ${() => css`
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    margin-left: 2.5rem;
    overflow-x: auto;
    padding-bottom: 0.25rem;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

type CategoryChipProps = TransientProps<{ active: boolean }>;

export const CategoryChip = styled.button<CategoryChipProps>`
  ${({ theme, $active }) => css`
    font-weight: 600;
    padding: 0.375rem 0.875rem;
    border-radius: 1.25rem;
    font-size: 0.75rem;
    cursor: pointer;
    white-space: nowrap;
    border: 1.5px solid
      ${$active ? theme.colors.brand.primary.default : theme.colors.base.border};
    transition: ${theme.transition.default};
    background: ${$active ? theme.colors.brand.primary.default : 'transparent'};
    color: ${$active
      ? theme.colors.brand.primary.text
      : theme.colors.foreground[80]};

    :hover {
      border-color: ${theme.colors.brand.primary.default};
      ${!$active &&
      css`
        background: ${theme.colors.brand.primary.opaque};
        color: ${theme.colors.brand.primary.default};
      `}
    }
  `}
`;

export const Wrapper = styled.section`
  ${() => css`
    display: flex;
    flex-direction: column;
    margin-left: 2.5rem;
    padding-right: calc(420px + 2rem);

    ${down('xl')} {
      padding-left: 0;
      padding-right: 0;
    }
  `}
`;
